module.exports = __webpack_public_path__ + "fontawesome-webfont.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/EZepeda/Desktop/Explora/adminexplora/~/font-awesome/fonts/fontawesome-webfont.eot
// module id = ../../../../font-awesome/fonts/fontawesome-webfont.eot
// module chunks = 2